import './owner-signature.css';

export function OwnerMark({size=18}) {
  return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none"><path d="m4 8 4 3 4-6 4 6 4-3-2 10H6L4 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M8 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
}

export default function OwnerSignature({palette,edition=false}) {
  const label=edition?'Owner edition':'Owner · TradeLog';
  const style=palette?{color:palette.gold,borderColor:`${palette.gold}66`,background:`${palette.gold}10`,fontFamily:palette.font,fontSize:13,padding:'7px 13px'}:undefined;
  return <span className="tl-owner-seal" style={style} title="The main TradeLog owner account"><OwnerMark size={palette?17:16}/>{label}</span>;
}
